import { render } from "./Cover.vue?vue&type=template&id=19ff16f3&scoped=true"
import script from "./Cover.vue?vue&type=script&lang=js"
export * from "./Cover.vue?vue&type=script&lang=js"

import "./Cover.vue?vue&type=style&index=0&id=19ff16f3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ff16f3"]])

export default __exports__